import React from 'react';
import {
    BANNERS_CAROUSEL_TYPE,
    CHOCOLATE_CAROUSEL_TYPE,
    CHOCOLATE_GRID_TYPE,
    DISCOVER_CAROUSEL_TYPE,
    GIGS_CAROUSEL_TYPE,
    GIGS_LISTING_TYPE,
    GIGS_VIEW_LISTING_TYPE,
    GUIDE_TYPE,
    PATTERNS_BANNER_TYPE,
    PRO_GIGS_CAROUSEL_TYPE,
    PRO_GIGS_VIEW_LISTING_TYPE,
    RECENTLY_VIEWED_TYPE,
    SERVICES_TYPE,
    SMALL_GIGS_LIST_VIEW_TYPE,
    DYNAMIC_CAROUSEL_TYPE,
    CHOICE_NESTED_TABS,
    BRICKS_LIST_TYPE,
    TRANSPARENT_CAROUSEL_TYPE,
    INSPIRE_SLIDING_CAROUSEL_TYPE,
    PATTERNS_SLIDING_CAROUSEL_TYPE,
    SELLERS_SLIDING_CAROUSEL_TYPE,
    SELLERS_GRID_VIEW_TYPE,
    SELLER_ROLES_SLIDING_CAROUSEL_TYPE,
} from '../../utils/constants';
import { componentMapperPropTypes, PersonalizedComponentMapperCommon } from './common';

import './style.scss';

export const PERSONALIZED_COMPONENTS = {
    [BANNERS_CAROUSEL_TYPE]: () => import(/* webpackChunkName: 'BannersCarousel' */ '../BannersCarousel'),
    [GIGS_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'GigCardCarouselWrapper' */ '../gigs/GigCardCarouselWrapper'),
    [PRO_GIGS_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'GigCardCarouselWrapper' */ '../gigs/GigCardCarouselWrapper'),
    [GIGS_LISTING_TYPE]: () =>
        import(/* webpackChunkName: 'GigCardListingsWrapper' */ '../gigs/GigCardListingsWrapper'),
    [GIGS_VIEW_LISTING_TYPE]: () => import(/* webpackChunkName: 'GigsListViewWrapper' */ '../gigs/GigsListViewWrapper'),
    [SMALL_GIGS_LIST_VIEW_TYPE]: () =>
        import(/* webpackChunkName: 'SmallListViewListingWrapper' */ '../gigs/SmallListViewListingWrapper'),
    [RECENTLY_VIEWED_TYPE]: () =>
        import(/* webpackChunkName: 'RecentlyViewedCarousel' */ '../gigs/RecentlyViewedCarousel'),
    [PRO_GIGS_VIEW_LISTING_TYPE]: () =>
        import(/* webpackChunkName: 'GigsListViewWrapper' */ '../gigs/GigsListViewWrapper'),
    [CHOCOLATE_GRID_TYPE]: () => import(/* webpackChunkName: 'ChocolateGridWrapper' */ '../gigs/ChocolateGridWrapper'),
    [CHOCOLATE_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'ChocolateCarouselWrapper' */ '../gigs/ChocolateCarouselWrapper'),
    [BRICKS_LIST_TYPE]: () => import(/* webpackChunkName: 'BricksListWrapper' */ '../gigs/BricksListWrapper'),
    [DYNAMIC_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'DynamicGigCardCarouselWrapper' */ '../gigs/DynamicGigCardCarouselWrapper'),
    [GUIDE_TYPE]: () => import(/* webpackChunkName: 'Guide' */ '../Guide'),
    [SERVICES_TYPE]: () => import(/* webpackChunkName: 'NextSteps' */ '../NextSteps'),
    [DISCOVER_CAROUSEL_TYPE]: () => import(/* webpackChunkName: 'DiscoverCarousel' */ '../DiscoverCarousel'),
    [PATTERNS_BANNER_TYPE]: () => import(/* webpackChunkName: 'PatternsBanner' */ '../PatternsBanner'),
    [PATTERNS_SLIDING_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'PatternsSlidingCarousel' */ '../PatternsSlidingCarouselBanner'),
    [CHOICE_NESTED_TABS]: () => import(/* webpackChunkName: 'MultiTabs' */ '../MultiTabs'),
    [TRANSPARENT_CAROUSEL_TYPE]: () => import(/* webpackChunkName: 'TransparentComponent' */ '../TransparentComponent'),
    [INSPIRE_SLIDING_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'InspireSlidingCarousel' */ '../InspireSlidingCarousel'),
    [SELLERS_SLIDING_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'SellersSlidingCarousel' */ '../sellers/SellersSlidingCarousel'),
    [SELLERS_GRID_VIEW_TYPE]: () => import(/* webpackChunkName: 'SellersGridView' */ '../sellers/SellersGridView'),
    [SELLER_ROLES_SLIDING_CAROUSEL_TYPE]: () =>
        import(/* webpackChunkName: 'RolesCarousel' */ '../RolesCarousel/RolesCarousel'),
};

export const PersonalizedComponentMapper = (props) => {
    const { type } = props.component;

    const PersonalizedComponent = PERSONALIZED_COMPONENTS[type];

    return (
        <PersonalizedComponentMapperCommon
            {...props}
            PersonalizedComponent={PersonalizedComponent}
            PersonalizedComponentMapper={PersonalizedComponentMapper}
            shouldLazyImport
        />
    );
};

PersonalizedComponentMapper.propTypes = componentMapperPropTypes;
